/// <reference path='../_all.ts' />

module userAdmin {
  'use strict';

  export class User {
    constructor(
      public UserName: string,
      public LastLoginDate: Date,
      public Id: string,
      public IsLockedOut: boolean,
      public IsApproved: boolean,
      public Groups: string[]
      ) { }
  }
  
  export class NewUserData {
    constructor(
      public UserName: string,
      public Password: string,
      public Comment: string
      ) { }
  }

  export class UpdateUserData {
    constructor(
      public IsApproved: boolean,
      public IsLockedOut: boolean,
      public Groups: string[]
      ) { }
  }


  

  export class Group {
    constructor(
      public Name: string,
      public Permissions: string[]
      ) { }
  }

  export class Permission {
    constructor(
      public ID: string,
      public Name: string,
      public Desc: string
      ) { }
  }

  
  export class UserAdminServiceData {
    constructor(
      public Users: { [name: string] : User } ,
      public Groups: { [name: string] : Group } ,
      public Permissions: { [name: string] : Permission } 
      ) { }
  }



}


 //"Users": {
 //   "051099@lsmtron.com": {
 //     "UserName": "051099@lsmtron.com",
 //     "LastLoginDate": "2009-09-18T08:21:57+02:00",
 //     "Id": "7bed68dd-8551-4b82-a276-2cf3106e2066",
 //     "IsLockedOut": true,
 //     "IsApproved": true,
 //     "Groups": [
 //       "Registrierter Benutzer"
 //     ]
 //   }
 // },

 // "Groups": {
 //   "Administration DSA": {
 //     "Name": "Administration DSA",
 //     "Permissions": [
 //       "Alle Preise",
 //       "Artikelsuche",
 //       "CRM Kontakte abfragen",
 //       "Dokumente bestellen",
 //       "Dokumentsuche",
 //       "Dokustufe 0 Produktion",
 //       "Dokustufe 1 Verkauf",
 //       "Dokustufe 2 Vertretungen",
 //       "Dokustufe 3 Service",
 //       "Dokustufe 4 Händler"
 //       ]
 //   }
 // },

 // "Permissions": {
 //   "Alle Preise": {
 //     "ID": "6e71044d-888b-42b2-95bd-17258f1c3888",
 //     "Name": "Alle Preise",
 //     "Desc": "Darf ALLE Artikel und deren Preise sehen."
 //   }
 // }
